import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MediaService } from './media.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http:HttpClient, private mediaService:MediaService) { }

  getVestigingen() {
    return this.http.get<any>(`${environment.apiBaseUrl}/vestigingen?populate=*`);
  }

  getVestiging(id:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/vestigingen?filters[id][$eq]=${id}&populate=*`);
  }

  populateVestiging(data:any) {
    let item = data;
    item.id = data.id;
    item.foto = this.mediaService.getMediaItemUrl(item.foto);
    item.banner_image = this.mediaService.getMediaItemUrl(item.banner_image, null);

    if(item.fotos_detail) {
      item.detailfotos = this.mediaService.getMediaItemUrls(item.fotos_detail);
    }

    return item;
  }
}
